<template>
  <section id="main-wrap" class="pure-g">  
    <div id="main-col" class="pure-u-3-5">

      <h3 class="browse-grapevines-heading">Browse grapevines</h3>

      <ul id="browse-grapevines" class="pure-g" v-images-loaded:on.progress="grapevineImageLoaded">
        <li v-for="grapevine in grapevines" class="big-grapevine-item pure-u-1-5" :data-id="grapevine.id">
          <router-link class="list-link" v-on:click.native="viewGrapevine()" v-bind:to="{ name: 'grapevine', params: { id: grapevine.id, name: encodeURIComponent(grapevine.name) } }"><div class="img-wrap"><span class="grapes-count">{{grapevine.count}}</span><span class="grapes-count-bg"></span><img class="grape-img" :src="grapevine.grapeImage" v-if="grapevine.grapeImage" /></div><div class="grapevine-details-wrap"><span class="grapevine-name">{{ grapevine.name }}</span></div></router-link>
        </li>
      </ul>

    </div>
  </section>

</template>

<script>
  /* global $, algoliasearch */
  import db from './firebaseInit'
  import firebase from 'firebase'
  import imagesLoaded from 'vue-images-loaded'

  export default {
    name: 'browse-grapevines',
    metaInfo: {
      title: 'Browse Grapevines',
      // override the parent template and just use the above title only
      titleTemplate: null
    },
    directives: {
      imagesLoaded,
    },
    data () {
      return {
        grapevineUserID: 'QxBYvA9ipPef5cOLYZKhdDv0rb03',
        isLoggedIn: false,
        grapevines: [],
        isLoading: false,
        lastVisible: null,
        enableLoadMore: false,
        pageLimit: 20,
        grapevinesLoaded: 0,
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        isPress: this.$globals.isPress
      }
    },
    created () {
      $('html, body').animate({ scrollTop: 0 }, 'slow')  
      this.showLoading()
      this.getGrapevines()
    },
    mounted () {
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      getGrapevines: function () {
        var vm = this
        vm.grapevines = []

        // Created Public
        var grapevineRef = db.collection(vm.grapevinesDatabase).where('userID', '==', vm.grapevineUserID).orderBy('grapeCount', 'desc').limit(200)
        if (this.isPress) {
          grapevineRef = db.collection(vm.grapevinesDatabase).limit(200)
        }
        grapevineRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log('fetch: ' + doc.id, ' => ', doc.data())
            let data = doc.data()
            console.log(data)
            var grapevineData = {
              name: data.name,
              id: doc.id,
              isReadOnly: false,
              grapes: data.grapes,
              grapeImage: null,
              count: data.grapes.length,
              isPrivate: data.privacy === 'private',
              created: data.createdTimestamp
            }
            // vm.storeGrapevineCount(doc.id, data.grapes.length)
            if (grapevineData.count > 0 && !vm.checkGrapevinePresent(vm.grapevines, grapevineData.id, true)) {
              vm.getGrapevineImage(grapevineData)
            }
          })
        })

        this.$eventHub.$emit('external-trigger-grapevine')
        this.hideLoading()
      },
      storeGrapevineCount: function (id, count) {
        let vm = this
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(id)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            console.log('store count: ' + count)
            grapevineRef.update({
              grapeCount: count
            })
          }
        })
      },
      checkGrapevinePresent: function (inArr, grapevineID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapevineID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      grapevinesSort: function () {
        let vm = this
        vm.grapevines.sort(function (a, b) {
          var countA = a.count ? parseInt(a.count) : 0
          var countB = b.count ? parseInt(b.count) : 0
          return countB - countA
        })
      },
      getGrapevineImage: function (grapevine) {
        let vm = this
        if (grapevine.grapes && grapevine.grapes.length > 0 && !grapevine.image) {
          db.collection(vm.grapesDatabase).where('id', '==', grapevine.grapes[0]).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapevine.grapeImage = grapeData.sourceImage
              if (vm.isPress) {
                if (!grapeData.sourceImage) {
                  grapevine.grapeImage = 'https://press.atgrapevine.com/static/img/' + grapeData.grapePublication.replace(/\s/g, '').toLowerCase() + '.png'
                }
              }
              vm.grapevines.push(grapevine)
            })
          })
        } else {
          vm.grapevines.push(grapevine)
          // vm.grapevinesSort()
        }
      },
      viewGrapevine: function () {
        this.$eventHub.$emit('external-trigger-grapevine')
      },
      grapevineImageLoaded(instance, image) {
        const result = image.isLoaded ? 'loaded' : 'broken';
        var i = $(image.img).parents('.big-grapevine-item').index()
        $(image.img).parents('.big-grapevine-item').transition({
          opacity: 1,
          delay: i*100,
          duration: 800,
          complete: function () {
            $(image.img).parents('.big-grapevine-item').addClass('item-animated');
          }
        });
      },
      loadMore: function () {
        var vm = this
        if (this.lastVisible && !this.isLoading && this.enableLoadMore) {
          this.isLoading = true
          var grapesRef = db.collection(vm.grapesDatabase).orderBy('updatedTimestamp', 'desc').startAfter(this.lastVisible).limit(vm.pageLimit)
          grapesRef.get().then((querySnapshot) => {
            this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
            console.log('load more activated, last visible: ' + this.lastVisible.data().id)
            querySnapshot.forEach((doc) => {
              if (doc.exists) {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                this.grapes.push(grapeData)
              }
            })
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          })
        }
      }
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  .load-more-button {
    cursor: pointer;
  }
  #browse-grapevines {
    margin-top: 20px;
    padding: 40px 20px 0;
    border-top: 1px solid #eaeaea;
  }
    .big-grapevine-item {
    padding: 0 10px;
    margin-bottom: 30px;
    text-align: left;
    box-sizing: border-box;
    opacity: 0;
  }
  .big-grapevine-item.item-animated {
    opacity: 1;
  }
  .big-grapevine-item a {
    text-decoration: none;
  }
  .big-grapevine-item .img-wrap {
    position: relative;
    margin-bottom: 15px;
    display: inline-block;
    overflow: hidden;
  }
  .big-grapevine-item .img-wrap .grapes-count {
    position: absolute;
    bottom: 2px;
    right: 3px;
    z-index: 3;
    font-size: 14px;
    color: #169a16;
    font-weight: bold;
    width: 14px;
    text-align: center;
    display: inline-block;
  }
/*  .big-grapevine-item .img-wrap .grapes-count {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 3;
    font-size: 13px;
    background: #169a16;
    font-weight: 100;
    width: 22px;
    text-align: center;
    display: inline-block;
    color: #fff;
    border-radius: 50%;
    height: 22px;
    line-height: 22px;
  }*/
  .big-grapevine-item .img-wrap .grapes-count-bg {
    height: 64px;
    width: 64px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    display: block;
    position: absolute;
    background: #fff;
    z-index: 2;
    bottom: -32px;
    right: -32px;
  }
  .big-grapevine-item img {
    max-width: 100%;
    display: block;
    transition: all 0.3s ease-in-out;
    z-index: 1;
  }
  .big-grapevine-item:hover img {
    opacity: 0.6;
  }
  .big-grapevine-item .grapevine-details-wrap {
    max-width: 128px;
  }
  .big-grapevine-item .grapevine-name {
    margin-bottom: 12px;
    position: relative;
    display: inline;
    font-size: 1.1em;
    color: #169a16;
    padding-bottom: 2px;
  }
  .big-grapevine-item .grapevine-name:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 2px;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid rgba(22,154,22,0.25);
  }
  .big-grapevine-item .grapes-count {
    font-size: 0.8em;
    display: block;
    color: #6D6C6A;
    margin-top: 8px;
    display: none;
  }
  .big-grapevine-item .grapes-count svg {
    margin-left: -2px;
    display: none;
    width: 20px;
    height: 20px;
    vertical-align: -5px;
  }
  .big-grapevine-item:first-child .grapes-count svg {
    display: inline-block;
  }
  @media only screen and (max-width: 1024px) {
    .big-grapevine-item {
      width: 33.3333%;
    }
  }

  @media only screen and (max-width: 767px) {
    #browse-grapevines {
      margin: 0 -10px 0;
      padding: 0;
      border-top: 0;
    }
    h3.browse-grapevines-heading {
      border-bottom: 1px solid #eaeaea;
      padding-bottom: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/BrowseGrapevines.vue